import { render, staticRenderFns } from "./CbsConstructorObjectCard.vue?vue&type=template&id=235f3e2c&scoped=true"
import script from "./CbsConstructorObjectCard.vue?vue&type=script&lang=js"
export * from "./CbsConstructorObjectCard.vue?vue&type=script&lang=js"
import style0 from "./CbsConstructorObjectCard.vue?vue&type=style&index=0&id=235f3e2c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "235f3e2c",
  null
  
)

export default component.exports